import styled from 'styled-components';
import { Link } from "react-router-dom";

export const LoginFormBlock = styled.div`
    margin-top: calc(100vh * (23 / 812));
`;

export const InputStyled = styled.input`
    border: 1px solid #d5d5d5;
    border-radius: calc(100vw*(5/375));
    width: 100%;
    padding: calc(100vw * (11 / 375));
    height: calc(100vw*(41/375));

    font-size: calc(100vw*(14/375));
    &::placeholder {
        color: #c6c6c6;
        font-size: calc(100vw*(14/375));
    }
    
    &:focus {
        border: solid calc(100vw*(1/375)) #ffcf19;
    }
`;


export const FieldWrapper = styled.div`
    margin-bottom: calc(100vw*(22/375));
`;

export const FieldTitle = styled.span`
    display: block;
    font-size: calc(100vw*(14/375));
    font-weight: 500;
    margin-bottom: calc(100vw*(8/375));
`

export const LoginBtn = styled.div`
    display: block;
    width: calc(100vw*(315/375));
    height: calc(100vw*(51/375));
    border-radius: calc(100vw*(4/375));
    line-height: calc(100vw*(51/375));
    text-align: center;
    margin-bottom: calc(100vw*(17/375));
    margin-top: calc(100vw*(-7/375));
    font-size: calc(100vw*(16/375));
    font-weight: bold;
    background-color: #ffcf19;
    color: #4e4e4e;
`

export const LoginDisabledBtn = styled(LoginBtn)`
    background-color: #d8d8d8;
    color: #989898;
`;

export const FormFooter = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: calc(100vw*(13/375));
`

export const FormLink = styled(Link)`
    font-size: calc(100vw*(14/375));
    line-height: 1.5;
    color: #707070;
    border-bottom: solid calc(100vw*(1/375)) #989898;
`;

export const CompanySignupLink = styled(Link)`
    padding: calc(100vw*(4/375)) calc(100vw*(7/375)); 
    background: #F7F7F7;
    border-radius: calc(100vw*(4/375));
    font-weight: normal;
    font-size: calc(100vw*(12/375));
    line-height: calc(100vw*(17/375)); 
    color: #707070;
`;

export const ErrorBlock = styled.div`
    margin-top: calc(100vw * (4 / 375));
`;

export const ErrorIcon = styled.img`
    width: calc(100vw * (12 / 375));
    margin-right: calc(100vw * (4.5 / 375));
`;

export const ErrorMessage = styled.p`
    display: inline-block;
    font-size: calc(100vw * (10 / 375));
    color: #de0000;
    
`;